<template>
    <div class="row">
        <div class="col-md-12 mg-t-10">
            <div class="card ht-100p">
                <div class="card-header d-flex align-items-center justify-content-between">
                    <h6 class="mg-b-0">Details</h6>
                    <div class="d-flex tx-18">
                        <a href="" class="link-03 lh-0"><i class="icon ion-md-refresh"></i></a>
                        <a href="" class="link-03 lh-0 mg-l-10"><i class="icon ion-md-more"></i></a>
                    </div>
                </div>
<!--                                <p v-if="company.company[0] == null" align="center"><bar-loader  class="custom-class" color="#6d0606" loading="loading" :size="150" sizeUnit="px"></bar-loader></p>-->
                <form class="p-4">
                    <div class="form-row">
                        <div class="col-md-6">
                            <div class="position-relative form-group"><label for="exampleEmail11" class="">Username</label><input v-model="model.custusername" id="exampleEmail11" placeholder="Username" type="text" class="form-control"></div>
                        </div>
                        <div class="col-md-6">
                            <div class="position-relative form-group"><label for="examplePassword11" class="">Full name</label><input v-model="model.fullname" id="examplePassword11" placeholder="Full name" type="text" class="form-control"></div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-md-6">
                            <div class="position-relative form-group"><label for="exampleEmail111" class="">Mobile number</label><input v-model="model.mobilenumber" id="exampleEmail111" placeholder="Mobile number" type="text" class="form-control"></div>
                        </div>
                        <div class="col-md-6">
                            <div class="position-relative form-group"><label for="examplePassword111" class="">Email address</label><input v-model="model.emailaddress" id="examplePassword111" placeholder="Email address" type="text" class="form-control"></div>
                        </div>
                    </div>
                    <br>
                    <h5 class="card-title">Roles</h5>

                    <div class="form-row">
                        <div class="col-md-4">
                            <div class="position-relative form-group">
                                <multiselect v-model="model.role" :options="roles" :searchable="false" :close-on-select="false" :show-labels="false" placeholder="Pick a role"></multiselect>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="position-relative form-group">
                                <multiselect v-model="model.canview" tag-placeholder="Can view Acc" placeholder="Can view Acc" label="name" track-by="code" :options="accountsList" :multiple="true" :taggable="true" @tag="addTag"></multiselect>
                                <!--                                <pre class="language-json"><code>{{ value  }}</code></pre>-->
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="position-relative form-group">
                                <multiselect v-model="model.cantrans" tag-placeholder="Can Transact Acc" placeholder="Can Transact Acc" label="name" track-by="code" :options="accountsList" :multiple="true" :taggable="true" @tag="addTag"></multiselect>
                                <!--                                <pre class="language-json"><code>{{ value  }}</code></pre>-->
                            </div>
                        </div>
                    </div>
                    <p v-if="cbank.cbankLoading" align="right"><bar-loader  class="custom-class" color="#6d0606" loading="loading" :size="150" sizeUnit="px"></bar-loader></p>
                    <p v-else align="right"><button @click="createUser()" type="button" style="background-color: #6d0606; border-color: #6d0606;" class="btn-shadow d-inline-flex align-items-center btn btn-success button">
                        Create User
                    </button></p>
                </form>
            </div><!-- card -->
        </div>
    </div><!-- row -->
</template>

<script>
    // import FlotChart from "../FlotChart";
    import {mapState} from 'vuex'
    export default {
        name: "TopCards",
        components:{

        },
        data(){
            return {
                value: [
                    { name: 'Javascript', code: 'js' }
                ],
                options: [

                ],
                model:{
                    orgId:'',
                    canview:'',
                    cantrans:'',
                    role:'',
                    custusername:'',
                    fullname:'',
                    mobilenumber:'',
                    emailaddress:''
                },
                roles: ['initiator','verifier','authorizer'],
                accountsA:[],
                accounts:[],
            };
        },
        methods: {
            nextClicked(currentPage) {
                console.log('next clicked', currentPage)
                if (currentPage >= this.steps.length-1)
                    this.createOfficer()
                return true; //return false if you want to prevent moving to next page
            },
            backClicked(currentPage) {
                console.log('back clicked', currentPage);
                return true; //return false if you want to prevent moving to previous page
            },
            async readOfficers(){
                await this.$store.dispatch("officer/updateOfficers", {
                    orgID: localStorage.orgID,
                    accID: localStorage.accID,
                    requestType: 'officer'
                }, {root: true})
            },
            showAlert(title, message) {
                const options = {title: title, size: 'sm'}
                this.$dialogs.alert(message, options)
                    .then(res => {
                        console.log(res) // {ok: true|false|undefined}
                    })
            },
            officerFiltered(_item) {
                return this.officer.officers.filter(function (el) {
                    return el.officerID == _item;
                });
            },
            addTag (newTag) {
                const tag = {
                    name: newTag,
                    code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
                }
                this.options.push(tag)
                this.value.push(tag)
            },
            async createUser(){
                if (this.model.fullname !== ''
                    && this.model.custusername !== ''
                    && this.model.mobilenumber !== ''
                    && this.model.emailaddress !== ''
                    && this.model.role !== ''
                    && this.model.canview !== ''
                    && this.model.cantrans !== ''
                )  {
                    // console.log(this.model);
                    let cv = '';
                    for (let index = 0; index < this.model.canview.length; index++) {
                        if(index === this.model.canview.length-1){
                            cv = cv+this.model.canview[index].code;
                        }else{
                            cv = cv+this.model.canview[index].code+',';
                        }
                        // console.log(cv)
                    }

                    let ct = ''
                    for (let index = 0; index < this.model.canview.length; index++) {
                        if(index === this.model.canview.length-1){
                            ct = ct+this.model.canview[index].code;
                        }else{
                            ct = ct+this.model.canview[index].code+',';
                        }
                        // console.log(ct)
                    }
                    this.model.customerid = this.company.account[0].accCustID;
                    this.model.customername = this.system.userInfo.lastName+' '+this.system.userInfo.firstName;
                    this.model.username = this.system.userInfo.phone;
                    this.model.viewaccount = cv;
                    this.model.transactaccount = ct;
                    this.model.orgId = localStorage.orgID;
                    this.model.dialogs = this.$dialogs;
                    console.log(this.model);
                    await this.$store.dispatch("cbank/createCbank", this.model, {root: true})
                    // return
                }else{
                    const options = {title: 'Error!', size: 'sm'};
                    this.$dialogs.alert('Empty field detected. Please fill fields', options)
                        .then(res => {
                            console.log(res) // {ok: true|false|undefined}
                        })
                }
            },
        },
        computed:{
            ...mapState([
                'system',
                'company',
                'cbank',
                'officer'
            ]),
            accountsList:{
                get(){
                    let acc = [];
                    let len = this.company.company[0] == null? 0 : this.company.company[0].accounts.length;
                    for (let i = 0; i < len; i++)
                        acc[i] = {
                            name: this.company.company[0].accounts[i].accNumber,
                            code: this.company.company[0].accounts[i].accNumber
                        };
                    return acc;
                },
                set(){

                }
            }
        }
    }
</script>

<style scoped>
    @media only screen and (min-width: 900px) {
        .top-card {
            width: 103%;
        }
    }
    @media only screen and (min-width: 707px) and (max-width: 900px) {
        .top-card {
            width: 104%;
        }
    }

    @media only screen and (min-width: 517px)  and (max-width: 707px) {
        .top-card {
            width: 105%;
        }
    }

    @media only screen and (min-width: 451px)  and (max-width: 517px) {
        .top-card {
            width: 106%;
        }
    }

    @media only screen  and (max-width: 451px) {
        .top-card {
            width: 107%;
        }
    }
    .h-100 {
        height: 100vh !important;
    }
    @media only screen and  (max-width: 991px) {
        .extra{
            display: none;
        }
    }
    .image-input{
        display: block;
        width: 100%;
        height: 300px;
        cursor: pointer;
        background-size: cover;
        background-position: center center;
    }

    .placeholder{
        background: #F0F0F0;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #333;
        font-size: 18px;
        font-family: Helvetica,serif;
    }

    .placeholder:hover{
        background: #E0E0E0
    }

    .file-input{
        display: none;
    }
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>